import React, { useCallback } from 'react';
import { Button, Container } from 'react-bootstrap';

import '../styles/PageNav.css';
import { array, bool, func, number } from 'prop-types';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const GO_TO_PAGE_STATIC_TEXT = 'Go to page ';
const PAGE_LIST_BUTTON_NUMBER_CLASSNAME = 'page--list-btn-number';

export default function PageNav({ curPage, totalPages, generatedPagesData, enablePrevNextButton = false, paginateUser = () => { } }) {
    const handlePrevPageClick = useCallback(() => {
        paginateUser(curPage - 1);
    }, [curPage, paginateUser]);
    const handleNextPageClick = useCallback(() => {
        paginateUser(curPage + 1);
    }, [curPage, paginateUser]);
    const getPageClickHandler = useCallback(
        (page) => () => paginateUser(page),
        [paginateUser]
    );
    return (<>
        {totalPages > 0 && (
            <div>
                Pages:
                <Container
                    className={'page--list-nav'}>
                    {(enablePrevNextButton && curPage >= 1) && (
                        <Button
                            aria-label={GO_TO_PAGE_STATIC_TEXT + (curPage - 1)}
                            onClick={handlePrevPageClick}
                            className={PAGE_LIST_BUTTON_NUMBER_CLASSNAME}>
                            <div
                                className={'d-flex align-items-center gap-1'}>
                                <IoIosArrowBack /> Prev
                            </div>
                        </Button>
                    )}
                    {generatedPagesData.map((page) => (
                        <Button
                            aria-label={GO_TO_PAGE_STATIC_TEXT + page.displayPage}
                            key={'page-' + page.page}
                            onClick={getPageClickHandler(page.page)}
                            className={PAGE_LIST_BUTTON_NUMBER_CLASSNAME}
                            disabled={curPage === page.page}>{page.displayPage}
                        </Button>
                    ))}
                    {(enablePrevNextButton && curPage < totalPages) && (
                        <Button
                            aria-label={GO_TO_PAGE_STATIC_TEXT + (curPage + 1)}
                            onClick={handleNextPageClick}
                            className={PAGE_LIST_BUTTON_NUMBER_CLASSNAME}>
                            <div
                                className={'d-flex align-items-center gap-1'}>
                                Next <IoIosArrowForward />
                            </div>
                        </Button>
                    )}
                </Container>
            </div>
        )}
    </>);
}

PageNav.propTypes = {
    curPage: number,
    totalPages: number,
    generatedPagesData: array,
    paginateUser: func,
    enablePrevNextButton: bool,
};